export enum RecallType {
  applicant = 'Applicant',
  applicationPayorMonthly = 'Payment.ApplicationPayorMonthly',
  applicationPayorInitial = 'Payment.ApplicationPayorInitial',
}
